import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { FormControl } from "@angular/forms";
import { LhStorageService } from "@hssa-itasia/ngx-util-core";
import { AddContractorComponent } from "../bog_tour/add-contractor/add-contractor.component";
import { AppService } from "../../app.service";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
// import {  }

@Component({
  selector: "app-search-users",
  templateUrl: "./search-users.component.html",
  styleUrls: ["./search-users.component.scss"],
  standalone: false
})
export class SearchUsersComponent implements OnInit, OnDestroy {
  searching: boolean = false;
  searchTerm: string = "";
  searchUsersList: any[] = [];
  copyUserList: any;
  lastFiveDiscussedUser: any = [];
  searchUser: any;

  fromAction: any;
  isAddDissUser : boolean = false;
  usersValues: any;
showBackBtn=true;
pageTitle='Select user';
  // ✅ added searchControl
  searchControl: FormControl = new FormControl("");
  keyboardHeight: number = 0;
  private keyboardListener: any;
  private searchSubscription: any;

  selectedUsers: any[] = [];

  constructor(
    private modalController: ModalController,
    private changeRef: ChangeDetectorRef,
    private lhStorage: LhStorageService,
    private appService: AppService
  ) { }

  ngOnInit() {
   // this.setupKeyboardListeners();
    console.log("SearchUsersComponent this.fromAction : ", this.fromAction);
    console.log("SearchUsersComponent this.usersValues : ", this.usersValues);
    console.log("SearchUsersComponent this.selectedUsers : ", this.selectedUsers);
  }

  setupKeyboardListeners() {
    if (Capacitor.isNativePlatform()) {
      this.keyboardListener = Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight;
        // Scroll the focused search bar into view
        // setTimeout(() => {
        //   const searchInput = document.getElementById('searchText');
        //   if (searchInput) {
        //     searchInput.scrollIntoView({
        //       behavior: 'smooth',
        //       block: 'start',
        //       inline: 'nearest'
        //     });
        //   }
        // }, 300);
      });

      Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0;
      });
    }
  }

  ngOnDestroy() {
    // if (this.keyboardListener) {
    //   this.keyboardListener.remove();
    // }
    // if (this.searchSubscription) {
    //   this.searchSubscription.unsubscribe();
    // }
  }

  async ionViewDidEnter() {
    this.searchUsersList = [];
    this.copyUserList = [];

    if (this.fromAction == "add-action") {
      this.isAddDissUser = false;
      await this.setAllAssignedToUsers();
      // this.searchUsersList = this.usersValues;
    } else if (this.fromAction == "add-discussed-user") {
      this.isAddDissUser = true;
      await this.setGAD_Employees();
    }
    this.updateListWithSelectedUsers();

    this.searchControl.setValue("");
    // this.getLastFiveDiscussedUser();
  }

  // async setGAD_Employees() {
  //   let tmp_GAD_emp_list = await localStorage.get("GAD_employee_list");
  //   let shield_info = await localStorage.get("currentRapid");
  //   let filtered = tmp_GAD_emp_list.filter(
  //     (obj: any) => obj.country == shield_info.country
  //   );
  //   let usersList = filtered[0].GAD_employee_list.filter(
  //     (obj: any) => obj.full_name_lower != undefined
  //   );
  //   let searchUsersList = usersList.sort((a, b) =>
  //     a.Email.localeCompare(b.Email)
  //   );
  //   this.copyUserList = usersList.sort((a, b) =>
  //     a.Email.localeCompare(b.Email)
  //   );
  //   // this.searchService.item = searchUsersList;
  //   // this.isSelected = false;
  // }

  // onSearchInput(event: any) {
  //   this.searching = true;
  //   this.searchTerm = event.target.value;
  //   this.changeRef.detectChanges();
  // }

  async setAllAssignedToUsers() {
    // let appData = await this.lhStorage.get("appData");
    // let usersByCountry = appData.usersByCountry || [];

    let usersByCountry = await this.prepareUsersList(true);

    let filtered = usersByCountry.map((item: any) => {
      const firstName = item.first_name || item.Fname || item.First_Name || '';
      const lastName = item.last_name || item.Lname || item.Last_Name || '';
      const computedFullName = item.Full_Name || item.full_name || `${firstName} ${lastName}`.trim();
      const email = item.email || item.Email || '';
      return {
        ...item,
        Email: email,
        Full_Name: computedFullName, // Ensure Full_Name is set
        Fname: firstName, // Ensure Fname is set
        Lname: lastName, // Ensure Lname is set
        First_Name: firstName, // Ensure First_Name is set
        Last_Name: lastName, // Ensure Last_Name is set
        full_name: computedFullName,
        full_name_lower: computedFullName.toLowerCase(),
        search_key: `${computedFullName} ${email}`.toLowerCase()
      };
    });


    // console.log("filtered = " + JSON.stringify(filtered));

    let usersList = filtered
      .filter((obj: any) => obj.full_name_lower != undefined)
      .map((item: any) => ({
        ...item,
        relationEmployee: item?.relation == 'Employee' ? true : false
      }));

    // keep both original & working list
    this.copyUserList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );

    this.searchUsersList = [...this.copyUserList]; // initial copy

    console.log("setAllAssignedToUsers usersList : ", this.searchUsersList);
  }

  async setGAD_Employees() {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    // console.log("tmp_GAD_emp_list = " + JSON.stringify(tmp_GAD_emp_list));
    let shield_info = await this.lhStorage.get("currentRapid");

    let filtered = tmp_GAD_emp_list.filter(
      (obj: any) => obj.Country == shield_info.Country
    );

   // console.log("filtered = " + JSON.stringify(filtered));

    let usersList = filtered[0].GAD_employee_list
      .filter((obj: any) => obj.full_name_lower != undefined)
      .map((obj: any) => {
        const firstName = obj.first_name || obj.Fname || obj.First_Name || '';
        const lastName = obj.last_name || obj.Lname || obj.Last_Name || '';
        const fullName = obj.Full_Name || obj.full_name || `${firstName} ${lastName}`.trim();
        const email = obj.Email || obj.email || '';
        return {
          ...obj,
          Full_Name: fullName, // Ensure Full_Name is set
          Fname: firstName, // Ensure Fname is set
          Lname: lastName, // Ensure Lname is set
          First_Name: firstName, // Ensure First_Name is set
          Last_Name: lastName, // Ensure Last_Name is set
          Email: email,
          search_key: `${fullName} ${email}`.toLowerCase(),
          relationEmployee: obj?.relation == 'Employee' ? true : false
        };
      });

    // keep both original & working list
    this.copyUserList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );

    this.searchUsersList = [...this.copyUserList]; // initial copy
  }

  // async getLastFiveDiscussedUser() {
  //   let lastFiveDisucssedUserList = await this.lhStorage.get(
  //     "lastFiveIDiscussedUsers"
  //   );
  //   this.lastFiveDiscussedUser = lastFiveDisucssedUserList
  //     ? lastFiveDisucssedUserList
  //     : [];
  // }

  onSearchInput(event: any) {
    // This is called when user types, but we also use valueChanges
    const inputValue = event.target?.value || "";
    this.searchTerm = inputValue;
    this.onSearchValueChange(inputValue);
  }

  clearSearch(){
    this.searchTerm =  "";
    this.searchUsersList = [...this.copyUserList];
  }

  onSearchValueChange(value: string) {
    this.searching = true;
    this.searchTerm = value || "";
      if(!value || value==""){
      this.searchUsersList = [...this.copyUserList];
        this.searching = false;
      return;
    }

     const searchLower = this.searchTerm.toLowerCase();

      this.searchUsersList = this.copyUserList.filter((user) => {
          return (user?.search_key && 
            user?.search_key.toLowerCase().includes(searchLower)
          );
        });

    this.searching = false;

//    console.log("----searching-----",searchLower,this.searchUsersList );

    //this.changeRef.detectChanges();
  }

  async callAddContractor() {
    this.closeBtnClick({ status: "add_user", data: "" });
  }

  userSelected(_selectedUser: any) {
    console.log('userSelected : ', _selectedUser);
    // if (this.fromAction == 'add-action' && !_selectedUser?.person_unique_id) return;
    if (_selectedUser?.selected || (this.fromAction == 'add-action' && !_selectedUser?.person_unique_id)) {
      return;
    } 

    this.closeBtnClick({ status: "ok", data: _selectedUser });
  }

  closeBtnClick(obj) {
    this.modalController.dismiss(obj);
  }

    async prepareUsersList(ncludeAllGAD = false) {
    const appData = await this.lhStorage.get('appData');
    const usersByCountry = appData?.usersByCountry ?? [];
    const usersByGAD = await this.appService.getGADEmployeeListByCountry() ?? [];
    const masterMap = new Map<string, any>();
    usersByGAD.forEach(gu => {
        const emailKey = (gu.Email || gu.email)?.toLowerCase().trim();
        if (emailKey) {
            masterMap.set(emailKey, { 
                ...this.buildDefaultEntityUser(gu), 
                ...gu,
                email: emailKey
            });
        }
    });

    usersByCountry.forEach(cu => {
        const emailKey = cu.email?.toLowerCase().trim();
        if (emailKey) {
            const existing = masterMap.get(emailKey);
            if (existing) {
                masterMap.set(emailKey, { ...existing, ...cu });
            } else {
                masterMap.set(emailKey, { ...cu, email: emailKey });
            }
        }
    });
    const updatedUsersList = Array.from(masterMap.values());
    return updatedUsersList;
}
  async prepareUsersListOld(includeAllGAD = false) {
    const appData = await this.lhStorage.get('appData');
    const usersByEntity = appData?.usersByCountry ?? [];

    const usersByGAD = await this.appService.getGADEmployeeListByCountry();

    console.log('prepareUsersList usersByEntity:', usersByEntity);
    console.log('prepareUsersList usersByGAD:', usersByGAD);

    const entityMap = new Map(
      usersByEntity
        .filter(u => u?.email)
        .map(u => [u.email.toLowerCase(), u])
    );

    const gadMap = new Map(
      usersByGAD
        .filter(u => u?.Email)
        .map(u => [u.Email.toLowerCase(), u])
    );

    let updatedUsersList: any[] = [];

    if (!includeAllGAD) {
      updatedUsersList = usersByEntity
        .map(eu => {
          const key = eu.email?.toLowerCase();
          const match = gadMap.get(key);
          return match ? { ...eu, ...(match as any) } : null;
        })
        .filter(Boolean); 
    } else {
      updatedUsersList = usersByGAD.map(gu => {
        const key = gu.Email?.toLowerCase();
        const match = entityMap.get(key) ?? this.buildDefaultEntityUser(gu);
        return { ...(match as any), ...gu };
      });
    }

    console.log('prepareUsersList updatedUsersList:', updatedUsersList);

    const notUser = updatedUsersList.filter(u => !u.person_unique_id);
    console.log('prepareUsersList notUser:', notUser);

    return updatedUsersList;
  }

  buildDefaultEntityUser(gadUser: any) {
    return {
      person_unique_id: "",
      Lname: gadUser?.Last_Name || "",
      plant: "",
      opco: "",
      phone_number: "",
      Fname: gadUser?.First_Name || "",
      department: "",
      region: "",
      person_id: 0,
      status: "",
      unique_id: "",
      id: "",
      country: gadUser?.Country || "",
      email: gadUser?.Email || "",
    };
  }

  updateListWithSelectedUsers() {
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.searchUsersList.forEach((user) => {
        let found = this.selectedUsers.find((selectedUser) => selectedUser.id == user.id);
        if (found){
          user.selected = true;
          user.btnText = "Selected";
        } else {
          user.selected = false;
          user.btnText = "Select";
        }
      })
    } else {
      this.searchUsersList.forEach((user) => {
        user.selected = false;
        user.btnText = "Select";
      })
    }
    console.log('updateListWithSelectedUsers this.searchUsersList:', this.searchUsersList);
  }

}
